<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="エクストラサイト設定参照(Type4)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn v-permission.config color="primary" @click="toChange"
                  >変更
                </v-btn>
                <v-btn
                  v-permission.config
                  v-if="!isPolicy"
                  color="primary"
                  @click="toDelete"
                  >削除</v-btn
                >
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col>
                <app-label-group label="サイト名" :value="extraSite.siteName" />
              </v-col>
            </v-row>
            <app-table
              :fields="extraData.fields"
              :items="extraData.items"
              primary-key="ipAddressId"
              :tr-class="() => undefined"
              density="compact"
            >
              <!-- アドレス名-->
              <template #cell(ipAddressName)="data">
                {{ $filter.emptyTo(data.value, "-") }}
              </template>
              <!-- ゾーン配置-->
              <template #cell(isPolicyInUse)="data">
                {{ $filter.enumTo(data.value, "isPolicyInUse") }}
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  DeleteType4ExtraSite,
  Type4ExtraSite,
  Type4ExtraSiteList,
  Type4InternetAddress,
} from "@/apis/Type4SiteApi";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { ApplianceInfo } from "@/apis/ContractApi";
import type { AppTableHeader } from "@/components/AppTable.vue";
import Type4ExtraSiteConfirmModal from "@/modals/type4/Type4ExtraSiteConfirmModal.vue";
import Type4ExtraSiteEdit from "@/modals/type4/Type4ExtraSiteEdit.vue";

export default defineComponent({
  name: "Type4ExtraSiteReference",
  props: {
    extraSite: {
      type: Object as PropType<Type4ExtraSiteList>,
      required: true,
    },
    type4Id: {
      type: String as PropType<ApplianceInfo["type4Id"]>,
      required: true,
    },
    type4SiteKeyId: {
      type: String as PropType<Type4ExtraSite["type4SiteKeyId"]>,
      required: true,
    },
  },
  data() {
    return {
      extraData: {
        fields: [
          {
            key: "ipAddressName",
            title: "アドレス名",
          },
          {
            key: "ipAddress",
            title: "アドレス",
          },
          {
            key: "isPolicyInUse",
            title: "ポリシー使用有無",
          },
        ] as AppTableHeader<Type4InternetAddress>[],
        items: [] as Type4InternetAddress[],
      },
    };
  },
  computed: {
    /** 遷移元がポリシー設定の場合は,true */
    isPolicy(): boolean {
      return this.$route.path === "/network/contract";
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.extraData.items = this.extraSite.addressList;
    },
    /** 変更機能 */
    async toChange() {
      await this.$modal.show(Type4ExtraSiteEdit, {
        extraSite: this.extraSite,
        type4Id: this.type4Id,
        type4SiteKeyId: this.type4SiteKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 削除機能 */
    async toDelete() {
      await this.$modal.show(Type4ExtraSiteConfirmModal, {
        message: "エクストラサイトを削除します。よろしいですか？",
      });

      const reqData: DeleteType4ExtraSite = {
        siteList: [this.extraSite.siteId],
        type4SiteKeyId: this.type4SiteKeyId,
      };

      await this.$api.type4SiteApi.postType4ExtraSiteDelete(
        this.type4Id,
        reqData
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
